import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { selectIsAuthenticated } from '../../store/slices/authSlice';

const PublicRoute = ({ children, restricted = false }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const location = useLocation();

  // Redux is already rehydrated by the time any route renders (App.js gates
  // the whole tree on PersistGate), so isAuthenticated is reliable here with
  // no extra loading state needed. This previously also checked a "login
  // mutation in flight" flag from authSlice, which meant clicking Login
  // unmounted this whole route (and the Login page's form state with it)
  // for the split second the request was pending.
  if (isAuthenticated && restricted) {
    const from = location.state?.from?.pathname || '/reporting';
    return <Navigate to={from} replace />;
  }

  return children;
};

export default React.memo(PublicRoute);